import styled from 'styled-components'
import ButtonStyle from './ButtonStyle'

const Button = styled.button`
    outline: none;
    border: none;
    ${ButtonStyle}
`

export default Button;